// extracted by mini-css-extract-plugin
export var layoutContainer = "_91-0";
export var layoutContainerNoRounding = "_91-6";
export var layoutContainerOpen = "_91-5";
export var layoutContainerResizing = "_91-1";
export var mainContent = "_91-2";
export var resizeDivider = "_91-3";
export var slidePanel = "_91-4";